import { Component, OnInit, Input, ViewEncapsulation, HostBinding, AfterViewInit } from '@angular/core';
import { MFormation } from '@argalis-apps/models';
import { CatalogConfigService } from '../../services/catalog-config/catalog-config.service';

@Component({
  selector: 'ags-fiche-formation-detail',
  templateUrl: './fiche-formation-detail.component.html',
  styleUrls: ['./fiche-formation-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FicheFormationDetailComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  @Input() infoFormation: MFormation.IFormInfo;

  public modalite;
  @Input('modalite')
  set _modalite(value) {
    this.modalite = value;
  }

  public closeItem: boolean[] = [];
  public detailItems = [1, 2, 3, 4, 5];
  public tab = [];
  constructor(catalogConfigService: CatalogConfigService) {
    this.themeFlag = `${this.themeFlag || ''} ${catalogConfigService.themingClassName}`;
  }

  ngOnInit() {
    this.initItemsInfo();
  }
  changeLogo(i) {
    this.tab = [];
    const cur = this.closeItem[i];
    this.closeItem = [];
    this.detailItems.forEach(_ => {
      this.closeItem.push(false);
      this.tab.push(false);
    });
    this.closeItem[i] = !cur;
    this.tab[i] = true;
    return this.tab[i];
  }
  initItemsInfo() {
    this.detailItems.forEach(_ => {
      this.closeItem.push(false);
      this.tab.push(false);
    });
    this.tab[0] = true;
    this.closeItem[0] = true;
  }
}
